import { C } from './styled';

const Logo = () => {
	return <C>The Love Pixel</C>;
};

export default Logo;
